webpackJsonp([84887730282209],{

/***/ 714:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"supportEmail":"support@FileForEIN.com"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---faq-02c3eaba1cbf0acdd496.js